import { dispatcher } from 'dispatcher';

const ON_CLOSE_PAGE_IN_POPUP_MAP = {
    'fn-registration-close': () => {
        window.Playtech.API.popup.showPopup('confirmation', {
            isModal: false,
            layer: 'HIGH_PRIORITY',
            className: 'confirm-close-registration',
            onDecline: () => dispatcher?.dispatch('pageInPopup:closed'),
            content: 'playtech.mobile.registration.confirmClosePopup.content',
            acceptBtnText: 'playtech.mobile.registration.confirmClosePopup.accept',
            declineBtnText: 'playtech.mobile.registration.confirmClosePopup.decline'
        });
    }
};

export const isPageInPopupModal = (dynamicTags, page) => {
    const modalPagesInPopup = dynamicTags.DTAG_MODAL_PAGES_AS_POPUPS;

    if (!modalPagesInPopup) {
        return false;
    }

    return modalPagesInPopup
        .replace(/\s/g, '')
        .split(',')
        .includes(page);
};

export const isPageInPopupHasThemeHeader = (dynamicTags, page) => {
    const pagesInPopupWithThemeHeader = dynamicTags.DTAG_HEADER_PAGES_AS_POPUPS;

    if (!pagesInPopupWithThemeHeader) {
        return false;
    }

    return pagesInPopupWithThemeHeader
        .replace(/\s/g, '')
        .split(',')
        .includes(page);
};

export const getPredefinedOnClose = rootClassNames => rootClassNames
    .split(' ')
    .filter(name => name)
    .reduce((acc, name) => {
        if (ON_CLOSE_PAGE_IN_POPUP_MAP[name]) {
            // eslint-disable-next-line no-param-reassign
            acc = ON_CLOSE_PAGE_IN_POPUP_MAP[name];
        }

        return acc;
    }, null);
